const Splash = () => (
  <div
    id='page-loader'
    className='fixed top-0 left-0 right-0 bottom-0 z-[200] flex items-center justify-center bg-paper'
  >
    <div className='h-[142px] w-[129px] bg-[url("/images/page-loader.svg")] bg-cover bg-center bg-no-repeat' />
  </div>
);

export default Splash;
